export default __webpack_public_path__ + "static/media/firebase.a4156cb6.png";